import handleTrackingAttribute from '../../../Assets/helpers/tracking/handle-tracking-attribute.js';

// Events that bubble
for (const type of ['click', 'submit', 'reset', 'play']) {
  handleTrackingAttribute(type);
}
